import React, { useEffect, useRef, useState } from 'react';
import WebViewer from '@pdftron/webviewer';

const pdftronLicenseKey = process.env.REACT_APP_PDFTRON_LICENSE_KEY;

interface Props {
    styles: any;
    document?: string | File;
}

export const DocumentViewer: React.FC<Props> = (props) => {
    const viewerRef = useRef(null);
    const webviewerInstance = useRef<any>(null);
    const [viewerReady, setViewerReady] = useState<boolean>(false);

    useEffect(() => {
        if (!viewerRef.current) {
            return;
        }
        // Make sure to copy the files from node_modules/@pdftron/public to /public/pdftron before goes to production
        WebViewer(
            {
                path: "/pdftron",
                licenseKey: pdftronLicenseKey,
                disabledElements: ["header", "toolsHeader","textHighlightToolButton","textUnderlineToolButton",
                "copyTextButton","textSquigglyToolButton","textStrikeoutToolButton","linkButton"],                
                fullAPI: true
            },
            viewerRef.current!
        ).then(instance => {
            webviewerInstance.current = instance;
            setViewerReady(true);
        });
    }, [])

    useEffect(() => {
        if(webviewerInstance.current && viewerReady && props.document) {
            webviewerInstance.current.UI.loadDocument(props.document);
        }
    }, [props.document, viewerReady])

    return <div style={props.styles} ref={viewerRef}></div>
}